import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { FormsModule } from "@angular/forms";

// Templates
import { TemplateFormComponent } from "./template-form/template-form.component";

import { AppComponent } from "./app.component";
import { HomeComponent } from "./components/home/home.component";
import { ImportsComponent } from "./components/imports/imports.component";
import { PageNotFoundComponent } from "./components/navmenu/not-found.component";
import { VersionComponent } from "./components/version/version.component";
import { TokenComponent } from "./components/token/token.component";
import { LogoffComponent } from "../login/logoff.component";
import { LoginComponent } from "../login/login.component";
import { ResetPasswordComponent } from './../auth/reset-password/reset-password.component';
import { AuthCallbackComponent } from "../auth-callback/auth-callback.component";
import { AnalyticsComponent } from "../analytics/analytics.component";
import { UnattendedChartComponent } from "../analytics/charts/unattended-chart.component";
import { AnalyticsTableComponent } from "../analytics/analytics-table.component";

import { HeaderComponent } from "./components/header/header.component";
import { SpinnerModule } from "./spinner.module";

// import { NavMenuModule } from './navmenu.module';
import { NavMenuComponent } from "../app/components/navmenu/navmenu.component";
import { NavMenuXSComponent } from "../app/components/navmenu-xs/navmenu-xs.component";

// import { HttpModule } from '@angular/http'; DEPRECATED
import { HttpClientModule, HttpClient } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { FlexLayoutModule } from "@angular/flex-layout";

// Angular Material
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from "./material.module";

//Msal 



// services
import { AppConfigService } from "../services/app-config.service";
import { AuthGuardPatientService } from "../auth/auth-guard-patient.service";
import { AuthGuardPatientProcedureService } from "../auth/auth-guard-patient-procedure.service";
import { AuthGuardProcedureProtocolService } from "../auth/auth-guard-procedure-protocol.service";
import { AuthGuardOrganisationService } from "../auth/auth-guard-organisation.service";
import { AuthGuardReportsService } from "../auth/auth-guard-reports.service";
import { AuthGuardReferralService } from "../auth/auth-guard-referral.service";
import { AuthService } from "../auth/auth.service";
import { AuthMsgService } from "../auth/auth-msg.service";
import { LogoUpdateService } from "../services/logo-update.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LocalisationService } from "../services/localisation.service";
import { OrgSettingsService } from "../org-settings/org-settings.service";
import { ContentService } from "../content/content.service";
import { PatientService } from "../patient/patient.service";
import { AppInsightService } from "../services/appinsight-service";
import { ImportsService } from "../app/components/imports/imports.service";
import { DentallyWizardService } from "../app/components/wizards/dentally/dentally-wizard.service";
import { AmplitudeService } from '../services/amplitude-service';

import { SimpleDialogComponent } from "./components/simple-dialog/simple-dialog.component";
import { TestCommonDialogModule } from "./test-common-dialog.module";
import { NotImplementedDialogModule } from "./not-implemented-dialog.module";
import { SurveyResultsSeeMoreDialogModule } from "./survey-results-seemore-dialog.module";
import { AddNotesDialogModule } from "./add-notes-dialog.module";
import { SurveyAutocompleteModule } from "./survey-autocomplete.module";
import { ScrollSpyModule } from "./scroll-spy.module";
import { PipesModule } from "./pipes.module";
import { NgInitDirectiveModule } from "./ng-init-directive.module";

// Translation pack
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// Charts
import { NgxChartsModule } from "@swimlane/ngx-charts";

// Mock-data
// import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
// import { InMemoryDataService }  from './in-memory-data.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "/assets/i18n/", ".json?v="+environment.version);
}

// Perfect Scrollbar Module
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

import { registerLocaleData } from "@angular/common";

import localeEs from "@angular/common/locales/es";
import localeEsExtra from "@angular/common/locales/extra/es";
registerLocaleData(localeEs, "es-ES", localeEsExtra);

import localeIt from "@angular/common/locales/it";
import localeItExtra from "@angular/common/locales/extra/it";
registerLocaleData(localeIt, "it-IT", localeItExtra);

import localeGb from "@angular/common/locales/en-GB";
import localeGbExtra from "@angular/common/locales/extra/en-GB";
registerLocaleData(localeGb, "en-GB", localeGbExtra);

import localeAu from "@angular/common/locales/en-AU";
import localeAuExtra from "@angular/common/locales/extra/en-AU";
registerLocaleData(localeAu, "en-AU", localeAuExtra);

import localeUs from "@angular/common/locales/en";
import localeUsExtra from "@angular/common/locales/extra/en";
registerLocaleData(localeUs, "en-US", localeUsExtra);

import localePl from "@angular/common/locales/pl";
import localePlExtra from "@angular/common/locales/extra/pl";
registerLocaleData(localePl, "pl-PL", localePlExtra);

import localePt from "@angular/common/locales/pt-PT";
import localePtExtra from "@angular/common/locales/extra/pt-PT";
registerLocaleData(localePt, "pt-PT", localePtExtra);

import { SidenavService } from "../services/side-bar.service";
//import { FreshdeskWidgetService } from "../services/freshdesk-widget.setvice";
import { HubSpotWidgetService } from "../services/hubspot-widget.service"; 
import { ConfirmMessageDialogModule } from "./confirm-message-dialog.module";
import { PatientProceduresService } from "../patient-procedures/patient-procedures.service";
import { OrgSettingsData } from "../org-settings/org-settings-data.service";
import { ErrorInterceptor } from "src/services/error.interceptor";
import { AlertComponent } from "./components/alert/alert.component";
import { DentallyWizardComponent } from "./components/wizards/dentally/dentallywizard.component";
import { DentallyConnectComponent } from "./components/wizards/dentally/connect/dentally-connect.component";
import { DentallyLearnComponent } from "./components/wizards/dentally/learn/dentally-learn.component";
import { DentallyPreviewComponent } from './components/wizards/dentally/preview/dentally-preview.component';
//import { NgxFreshdeskWebwidgetConfig, NgxFreshdeskWebwidgetModule } from 'ngx-freshdesk-webwidget';
import { environment } from "src/environments/environment";
import userflow from "userflow.js";
import { ProgressStepperComponent } from "./components/wizards/dentally/progress-stepper/progress-stepper.component";
import { DentallyTreatmentsDialog } from "./components/wizards/dentally/preview/dialogs/dentally-treatments.dialog";
import { CommunicationPreviewDialog } from "./components/wizards/dentally/preview/dialogs/communication-preview.dialog";
import { SurveyDetailsModule } from "src/content/survey-details/survey-details.module";
import { DisableConfirmationDialog } from "./components/wizards/dentally/preview/dialogs/disable-confirmation.dialog";
import { DentallyStartComponent } from "./components/wizards/dentally/start/dentally-start.component";
import { WelcomeWizardDialog } from "./components/wizards/dentally/connect/dialogs/welcome-wizard.dialog";
import { LaunchButtonComponent } from "./components/launch-button/launch-button.component";
import { LaunchButtonDialogComponent } from "./components/launch-button/launch-button-dialog/launch-button-dialog.component";
import { VisitTypeService } from "../org-settings/visit-type.service";
import { initHeap } from '../utils/heap';
import { MSALInstanceFactory, MSALInterceptorConfigFactory } from '../auth/msal/msal-config';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService } from 'src/auth/msal';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from 'src/auth/msal/constants';
import { InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration } from 'src/auth/msal/msal-guard-config';
import { ErrrorComponent } from './components/errror/errror.component';
import { CustomizeDialogComponent } from './components/dialogs/customize-dialog/customize-dialog.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

const appInitializerFn = (appConfigService: AppConfigService, amplitudeService: AmplitudeService) => {
  return () => {
    userflow.init(environment.userflow_token);
    amplitudeService.init(appConfigService.getConfig().amplitude_key);
    initHeap(appConfigService.getConfig().heap_key);
  };
};

@NgModule({
  declarations: [
    AppComponent,    
    VersionComponent,
    TokenComponent,
    LoginComponent,
    LogoffComponent,
    ResetPasswordComponent,
    AuthCallbackComponent,
    HomeComponent,
    ImportsComponent,
    TemplateFormComponent,
    PageNotFoundComponent,
    HeaderComponent,
    DentallyWizardComponent,
    DentallyConnectComponent,
    DentallyLearnComponent,
    DentallyPreviewComponent,
    DentallyStartComponent,
    SimpleDialogComponent,
    CustomizeDialogComponent,
    AnalyticsComponent,
    UnattendedChartComponent,
    AnalyticsTableComponent,
    NavMenuComponent,
    NavMenuXSComponent,
    AlertComponent,
    ProgressStepperComponent,
    DentallyTreatmentsDialog,
    CommunicationPreviewDialog,
    DisableConfirmationDialog,
    WelcomeWizardDialog,
    LaunchButtonComponent,
    LaunchButtonDialogComponent,
    ErrrorComponent
  ],
  entryComponents: [
    SimpleDialogComponent,
    DentallyTreatmentsDialog,
    CommunicationPreviewDialog,
    DisableConfirmationDialog,
    WelcomeWizardDialog,
    LaunchButtonDialogComponent,
    CustomizeDialogComponent
  ],
  imports: [
    // NavMenuModule,
    BrowserModule,
    BrowserAnimationsModule,
    // NoopAnimationsModule,
    MaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    TestCommonDialogModule,
    NotImplementedDialogModule,
    SurveyResultsSeeMoreDialogModule,
    ConfirmMessageDialogModule,
    AddNotesDialogModule,
    SurveyAutocompleteModule,
    ScrollSpyModule,
    NgInitDirectiveModule,
    PerfectScrollbarModule,
    // The HttpClientInMemoryWebApiModule module intercepts HTTP requests
    // and returns simulated server responses.
    // Remove it when a real server is ready to receive requests.
    // HttpClientInMemoryWebApiModule.forRoot(
    //  InMemoryDataService, { dataEncapsulation: false }
    // ),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    SpinnerModule,
    NgxChartsModule,
    PipesModule,
    SurveyDetailsModule,
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService, AmplitudeService],
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthInterseptorService,
    //   multi: true,
    //},
    { provide: HTTP_INTERCEPTORS, 
      useClass: ErrorInterceptor, 
      multi: true
    },  
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect
      } as MsalGuardConfiguration
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    AuthGuardPatientService,
    AuthGuardPatientProcedureService,
    AuthGuardProcedureProtocolService,
    AuthGuardOrganisationService,
    AuthGuardReferralService,
    AuthGuardReportsService,
    OrgSettingsService,
    ContentService,
    PatientService,
    AuthMsgService,
    LogoUpdateService,
    LocalisationService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    SidenavService,
    //FreshdeskWidgetService,
    HubSpotWidgetService,
    AppInsightService,
    ImportsService,
    PatientProceduresService,
    {
      provide: OrgSettingsData,
      useFactory: OrgSettingsData.getInstance,
      deps: [HttpClient, AppConfigService],
    },
    DentallyWizardService,
    VisitTypeService,
    AmplitudeService,    
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
